<template>
	<div ref="ocrFileUpload" class="dialog-container">
		<div class="dialog" style="max-height: 860px; transform: translate(0, -420px); max-width: 1650px;">
			<form @submit.stop="doValidation()">
				<div class="top" style="height: 30px; margin-bottom: 10px;">
					<p class="txt-crud-title">
						Get Ocr
					</p>
				</div>
				<div class="survey-name-ocr">
					<div class="survey-name-label">
						Select Template
					</div>
					<div class="survey-name-input">
						<select
							ref="ocrTemplateSelect"
							name="ocrName"
							class="select-crud"
							:class="errors.has('items.ocrName') ? 'input-crud-error' : ''"
							v-model="items.ocrName"
							v-validate="'required'"
							@change="selectOcrTemplate($event.target.value)"
						>
							<option value="" disabled>-- Select --</option>
							<option v-for="(ocrTemplate, index) in ocrTemplateList" :key="index" :value="ocrTemplate.ocrNo">
								{{ ocrTemplate.ocrName }}
							</option>
						</select>
					</div>
					<div class="survey-name-label">
						Image Upload
					</div>
					<div class="survey-name-input">
						<input
							type="file"
							name="myfile"
							ref="myfile"
							v-validate="'required'"
							enctype="multipart/form-data"
							multiple="false"
							hidden
							@change="upload($event.target.name, $event.target.files)"
							@drop="upload($event.target.name, $event.target.files)"
						/>
						<input
							ref="fileName"
							style="border-radius: 0px;"
							type="text"
							class="file-input-crud elipsis-input"
							:title="fileName"
							:value="fileName"
							readonly
						/>
						<button type="button" class="file-btn-crud" @click.stop="openUploader()">
							Upload
						</button>
					</div>
				</div>
				<!-- 중앙 Survey 생성 영역 -->
				<div
					class="survey-center-ocr"
				>
					<div
						ref="uploadFile"
						v-if="!isDrawImage"
						class="survey-left-ocr"
						@click.stop="openUploader()"
					>
						+Upload File
					</div>
					<div
						ref="imageViewer"
						v-if="isDrawImage"
						class="survey-left-ocr"
					>
						<div class="pdf-container">
							<div class="canvas-container" :class="{'canvas-active': selectedOcrField}">
								<!-- <img :src="imageUrl" class="image-viewer" ref="imageViewer" /> -->
								<canvas 
									ref="drawingCanvas" 
									class="drawing-canvas"
								></canvas>
							</div>
							<div class="canvas-controls" v-if="selectedOcrField">
								<button type="button" class="canvas-control-btn" @click="deselectOcrField">
									<span>Exit Drawing Mode</span>
								</button>
							</div>
						</div>
					</div>
					<div
						class="survey-right-ocr"
					>
						<div
							class="field-spec-header"
						>
							Parsing Result
						</div>
						<div class="field-parsed-result">
							<table
								class="tb-list-vertical no-cursor hide"
								ref="parsedResultTable"
							>
								<colgroup>
									<col width="80px" />
									<col width= "auto" />
									<col width= "20%" />
									<col width= "20%" />
									<col width= "20%" />
								</colgroup>
								<thead>
									<tr>
										<th>
											<input type="checkbox" v-model="selectAll" @change="selectAllFields" />
										</th>
										<th>Entity</th>
										<th>Result</th>
										<th>Auto Edit</th>
										<th>Result(Edit)</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(field, index) in ocrFieldList" :key="index" :class="{'edit-parsed': field.editParsedData, 'check-row': field.checked}">
										<td><input type="checkbox" v-model="field.checked" /></td>
										<td>
											<input
												type="text"
												class="tb-list-input__readonly elipsis-row"
												:title="field.fieldName"
												v-model="field.fieldName"
												readonly
											/>
										</td>
										<td>
											<div v-if="field.fieldType === 'check'">
												<div v-if="field.parsedData === '☑'">
													{{ field.checkOptions.filter(option => option.checkValue === field.checkValue)[0].checkOption }}
												</div>
												<div v-else>
													{{ field.parsedData}}
												</div>
											</div>
											<div v-else>
												{{ field.parsedData }}
											</div>
										</td>
										<td>
											{{ field.autoEditData }}
										</td>
										<td>
											<select
												v-if="field.fieldType === 'check'"
												ref="checkValueSelect"
												name="checkValue"
												class="select-crud"
												:class="errors.has('checkValue') ? 'input-crud-error' : ''"
												v-model="field.editParsedData"
												v-validate="'required'"
												data-vv-as="checkValue"
												@click.stop=""
												@change.stop=""
											>
												<option v-for="(checkOption, index) in field.checkOptions" :key="index" :value="checkOption.checkValue">
													{{ checkOption.checkOption }}
												</option>
											</select>
											<input
												v-else
												type="text"
												class="tb-list-input"
												v-model="field.editParsedData"
											/>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="bottom" style="margin-top: 10px;">
					<button type="button" class="btn-save fright" title="Save" @click.stop="doSave()">
						Save
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" style="margin-right: 10px;" @click="doCancel()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

export default {
	name: "OcrFileUpload",
	components: {},
	created() {
		this.logger.debug(this, "created()");
		this.items.pageNo = this.param.pageNo;
		this.items.projectNo = this.param.projectNo;
		this.items.screeningNo = this.param.screeningNo;
		this.items.visitNo = this.param.visitNo;
		
		this.selectOcrTemplateList();
		this.setDefaultSelect();
		this.getAccessList('PAGE');
		this.getProjectStateCd();
	},
	beforeDestroy() {},
	mounted() {},
	watch: {
		isDrawImage(newVal) {
			if (newVal) {
				this.$nextTick(() => {
					this.initializeCanvas();
				});
			}
		},
	},
	data() {
		return {
			items: {},
			accessList: [],
			projectStateCd: "",
			repeatYn: "",
			defaultField: [],
			defaultCellId: [],
			// 엑셀 관련 데이터
			isTypingEdit: false,
			tableRow: 0,
			tableCol: 0,
			tableData: {},
			columnInfo: {},
			rowInfo: {},
			tableDrag: {
				isDrag: false,
				startId: "",
				endId: ""
			},
			clipBoard: {},
			ocrTemplateList: [],
			ocrTemplate: {},
			ocrFieldList: [],
			ocrFieldListLength: 0,
			selectedOcrField: null,
			fileName : "(100MB, Formats:PDF)",
			ocrFile: null,
			imageInfo: {
				imageUrl: "",
				imageWidth: 0,
				imageHeight: 0,
			},
			isDrawImage: false,
			imageObj: null,
			startX: 0,
			startY: 0,
			rectangle: null,
			parsedData: {},
			selectAll: false,
			ocrFieldListChecked: [],
			ocrEntityList: [],
			progress: 0,
		}
	},
	props: {
		param: {
			type: Object,
			required: true
		},
		value: {
			type: Array,
			default: function() {
				return [];
			},
		},
	},
	computed: {},
	methods: {
		selectOcrTemplateList() {
			this.logger.debug(this, "selectOcrTemplateList()");
			EventBus.$emit("project-loading", true);
			axios
				.post(this.config.contextRoot + "/ocr/selectListByCondition.do", this.items)
				.then((response) => {
					this.ocrTemplateList = response.data.ocrTemplateList;
					this.$nextTick(function () {
						setTimeout(function() {
							EventBus.$emit("project-loading", false);
						}.bind(this), 400);
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		setDefaultSelect() {
			this.logger.debug(this, "setDefaultSelect()");
			this.$nextTick(() => {
				if (this.$refs.ocrTemplateSelect) {
					this.items.ocrName = "";
				}
			});
		},
		generateGrid() {
			let usedKey = [];
			
			for(let col = 1; col <= this.tableCol; col++) {
				const columnId = String.fromCharCode(64 + col);
				if (!this.columnInfo[columnId]) {
					this.$set(this.columnInfo, columnId, { width: "100%" });
				}
			}
			
			if (this.isManualAdjustment) {
				this.handleManualAdjustment();
			}
			
			for(let col = 1 ; col <= this.tableCol ; col++)
			{
				for(let row = 1 ; row <= this.tableRow ; row++)
				{
					// cell Data 생성
					let keys = Object.keys(this.tableData);
					let id = String.fromCharCode(64 + col) + row;
					
					usedKey.push(id);
					if(keys.indexOf(id) < 0)
					{
						let data = {
							isFocus: false,
							isExpand: false,
							expandCol: 1,
							expandRow: 1,
							repeatCol: 1,
							repeatRow: 1,
							expandRoot: "",
							repeatRoot: "",
							isHeader: false,
							isText: false,
							isRepeat: false,
							align: "left",
							text: "",
							field: {}
						};
						this.$set(this.tableData, id, data);
					}
				}
			}
			
			// 미사용 Cell Data 삭제
			let keyArray = Object.keys(this.tableData);
			for(let i = 0 ; i < keyArray.length ; i++)
			{
				if(usedKey.indexOf(keyArray[i]) < 0)
				{
					if(this.tableData[keyArray[i]].isExpand)
					{
						let rootId = this.tableData[keyArray[i]].expandRoot;
						let rootStartCol = Number(rootId.slice(0, 1).charCodeAt(0));
						let rootEndCol = Number(rootStartCol + this.tableData[rootId].expandCol - 1);
						let rootStartRow = Number(rootId.slice(1));
						let rootEndRow = Number(rootStartRow + this.tableData[rootId].expandRow - 1);
						for(let c = rootStartCol ; c <= rootEndCol ; c++)
						{
							for(let r = rootStartRow ; r <= rootEndRow ; r++)
							{
								let id = String.fromCharCode(c) + r;
								this.$set(this.tableData[id], "isFocus", false);
								this.$set(this.tableData[id], "isExpand", false);
								this.$set(this.tableData[id], "expandCol", 1);
								this.$set(this.tableData[id], "expandRow", 1);
								this.$set(this.tableData[id], "expandRoot", "");
								this.$set(this.tableData[id], "isRepeat", false);
								this.$set(this.tableData[id], "repeatCol", 1);
								this.$set(this.tableData[id], "repeatRow", 1);
								this.$set(this.tableData[id], "repeatRoot", "");
							}
						}
					}
					this.$delete(this.tableData, keyArray[i]);
				}
			}
		},
		cellStyle(id) {
			let style = {};
			let cell = this.tableData[id];
			
			if(cell.isExpand && cell.expandCol < 2 && cell.expandRow < 2)
			{
				style.display = "none";
			}
			if(cell.isHeader)
			{
				style.backgroundColor = "#f5f5f5";
				style.fontWeight = "600";
			}
			if(cell.isFocus)
			{
				style.backgroundColor = "#00579211";
			}
			if(this.dragData.isDrag)
			{
				style.opacity = "0.9";
			}
			if(this.preview.isPreview && this.preview.cellId == id)
			{
				style.backgroundColor = "#eef4f8";
			}
			
			
			style.textAlign = cell.align;
			style.justifyContent = cell.align;
			
			return style;
		},
		getAccessList(category){
			axios
				.post(this.config.contextRoot + "/access/getCategoryPrivilegeList.do", {privilegeCategory: category})
				.then((response) => {
					this.accessList = response.data.privilegeList;
					this.accessList.forEach((obj) =>{
						this.workCheck(obj);
					})
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		async workCheck(obj){
			let item = {};
			item = {
				userId: sessionStorage.getItem("userId"),
				projectNo: this.param.projectNo,
				privilegeTypeCd: obj.privilegeTypeCd,
				privilegeCategory: obj.privilegeCategory,
				privilegeName: obj.privilegeName
			}
			obj.isAccess = await this.$accessAuth(item);
		},
		workAccessCheck(name){
			for(let  i = 0; i < this.accessList.length; i++){
				if(this.accessList[i].privilegeName == name){
					return this.accessList[i].isAccess;
				}
			}
		},
		getProjectStateCd() {
			// project 셋팅
			axios
				.post(this.config.contextRoot + "/project/select.do", {projectNo: this.$route.params.projectNo})
				.then((response) => {
					this.projectStateCd = response.data.item.projectStateCd;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		handleManualAdjustment() {
			this.isManualAdjustment = !this.isManualAdjustment;
			const widthColumns = document.getElementsByClassName("column-width");
			widthColumns.forEach((element) => {
				if (this.isManualAdjustment) {
					// column-width의 hide 클래스 제거
					element.classList.remove("hide");
				}
				else {
					// column-width의 hide 클래스 추가
					element.classList.add("hide");
				}
			});
		},
		getUrl(file) {
			return new Promise((resolve, reject) => {
				var reader = new FileReader();
				reader.onloadend = (e) => {
					let content = e.target.result;
					resolve(content);
				};
				reader.onerror = (e) => {
					reject(e);
				}
				reader.readAsDataURL(file);
			});
		},
		selectOcrTemplate(ocrNo) {
			this.logger.debug(this, "selectOcrTemplate()");
			this.extractOcrField(ocrNo);
		},
		async extractOcrField(ocrNo) {
			this.logger.debug(this, "extractOcrField()");
			this.items.ocrNo = ocrNo;
			
			EventBus.$emit("project-loading", true);
			const ocrFieldResponse = await axios.post(
				this.config.contextRoot + "/ocr/field/selectListByPage.do",
				this.items
			);
			
			this.ocrFieldList = ocrFieldResponse.data.ocrFieldList;
			this.ocrFieldListLength = this.ocrFieldList.length;
			
			console.log(`ocrFieldList: ${JSON.stringify(this.ocrFieldList)}`);
			
			const ocrFieldList = ocrFieldResponse.data.ocrFieldList || [];
			const updatedOcrFieldList = [];
			for (const field of ocrFieldList) {
				let ocrFieldType = field.fieldType || 'square';
				
				// area 객체 구성
				const area = {
					x: parseFloat(field.areaX) || 0,
					y: parseFloat(field.areaY) || 0,
					width: parseFloat(field.areaWidth) || 0,
					height: parseFloat(field.areaHeight) || 0
				};
				
				// position 배열 구성
				const position = [
					parseFloat(field.topLeftX) || 0,
					parseFloat(field.topLeftY) || 0,
					parseFloat(field.bottomRightX) || 0,
					parseFloat(field.bottomRightY) || 0
				];
				
				if (ocrFieldType === 'check') {
					const fieldOptionsResponse = await axios.post(
						this.config.contextRoot + "/field/select/fieldOptions.do",
						{fieldNo: field.fieldNo}
					);
					const fieldOptions = fieldOptionsResponse.data.fieldOptions;
					let options = [];
					let checkOptions = [];
					let checkValues = [];
					if(fieldOptions.fieldTypeCd === '03') {
						checkOptions = fieldOptions.radioOptionsLabel.split(';');
						checkValues = fieldOptions.radioOptionsValue.split(';');
					}
					else if(fieldOptions.fieldTypeCd === '04') {
						checkOptions = fieldOptions.checkboxOptionsLabel.split(';');
						checkValues = fieldOptions.checkboxOptionsValue.split(';');
					}
					else if(fieldOptions.fieldTypeCd === '05') {
						checkOptions = fieldOptions.selectOptionsLabel.split(';');
						checkValues = fieldOptions.selectOptionsValue.split(';');
					}
					checkValues.forEach((checkValue, index) => {
						options.push({
							checkOption: checkOptions[index],
							checkValue: checkValue
						});
					});
					field.checkOptions = options;
				}
				updatedOcrFieldList.push({
					...field,
					ocrFieldType,
					area,
					position,
				});
			}
			this.ocrFieldList = updatedOcrFieldList;
			
			this.ocrFieldListLength = this.ocrFieldList.length;
			
			this.$nextTick(function () {
				setTimeout(function() {
					EventBus.$emit("project-loading", false);
				}.bind(this), 400);
			});
		},
		openUploader() {
			this.logger.debug(this, "openUploader()");
			this.$refs.myfile.click();
		},
		async chunkUpload(name, files) {
			this.logger.debug(this, "chunkUpload()");
			
			// this.ocrFieldList 이 비어있으면 업로드 불가
			if (this.ocrFieldList.length === 0) {
				this.$alert("Please select a template first.", "Warning", "warning");
				return;
			}
			
			try {
				const file = files[0];
				this.fileName = file.name;
				this.ocrFile = file;
				
				const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
				if (file.size > MAX_FILE_SIZE) {
					throw new Error("File size exceeds the 100MB limit.");
				}
				
				EventBus.$emit("project-loading", true);
				this.updateProgress(0);
				
				// 청크 단위 파일 업로드
				const chunkResponse = await this.uploadInChunk(name, file);
				console.log(chunkResponse); // data.uploadFile(commonFileVo), success, chunkIndex
				
				
				
				
			}
			catch (error) {
				this.handleUploadError(error);
			}
			finally {
				EventBus.$emit("project-loading", false);
				this.updateProgress(100);
			}
		},
		async uploadInChunk(name, file, chunkSize = 1024 * 1024) {
			this.logger.debug(this, "uploadInChunk()");
			const chunks = Math.ceil(file.size / chunkSize);
			const uploadId = this.generateUniqueId();
			let uploadedChunks = 0;
			
			for (let i = 0; i < chunks; i++) {
				const start = i * chunkSize;
				const end = Math.min(start + chunkSize, file.size);
				const chunk = file.slice(start, end);
				
				const formData = new FormData();
				formData.append('file', chunk);
				formData.append('chunkIndex', i);
				formData.append('totalChunks', chunks);
				formData.append('uploadId', uploadId);
				formData.append('fileName', file.name);
				formData.append(name, file, file.name);
				
				try {
					const chunkResponse = await axios.post(this.config.contextRoot + "/common/file/uploadChunk.do", formData, {
						onUploadProgress: (progressEvent) => {
							const percentCompleted = Math.round(
								((i * chunkSize) + progressEvent.loaded) / file.size * 100
							);
							this.updateProgress(percentCompleted);
						}
					});
					uploadedChunks++;
					this.updateProgress((uploadedChunks / chunks) * 100);
					return chunkResponse;
				}
				catch (error) {
					this.handleUploadError(error);
					return null;
				}
			}
		},
		async processOcrWithWorker(imageData, ocrFields, parsedResults) {
			this.logger.debug(this, "processOcrWithWorker()");
			return new Promise((resolve) => {
				const worker = new Worker("./workers/ocr.worker.js");
				worker.postMessage({
					imageData,
					ocrFields,
					parsedResults
				});
				worker.onmessage = (event) => {
					if (event.data.type === 'complete') {
						worker.terminate();
						resolve(event.data.results);
					}
				};
			});
		},
		handleUploadError(error) {
			const errorMessages = {
				"Only PDF files are supported.": "Only PDF files are supported.",
				"File size exceeds the 100MB limit.": "File size exceeds the 100MB limit.",
				"Documents with more than 1 page are not supported.": "Documents with more than 1 page are not supported."
			};
			
			const message = errorMessages[error.message];
			this.$alert(message, "Error", "error");
			this.fileName = "(100MB, Formats: PDF)"
			this.ocrFile = null;
			this.logger.error(this, "Upload Error: ", error);
		},
		updateProgress(percent) {
			this.logger.debug(this, "updateProgress()", percent);
			this.progress = percent;
		},
		generateUniqueId() {
			return Date.now().toString(36) + Math.random().toString(36).substr(2);
		},
		async upload(name, files) {
			this.logger.debug(this, "upload()");
			// this.ocrFieldList 이 비어있으면 업로드 불가
			if (this.ocrFieldList.length === 0) {
				this.$alert("Please select a template first.", "Warning", "warning");
				return;
			}
			try {
				const formData = new FormData();
				
				// 파일 1개 제한
				for (let idx = 0; idx < Math.min(files.length, 1); idx++) {
					formData.append(name, files[idx], files[idx].name);
					this.fileName = files[idx].name;
					this.ocrFile = files[idx];
				}
				
				// 로딩 바 표시
				EventBus.$emit("project-loading", true);
				
				// Step 1: 파일 업로드
				const response = await axios.post(this.config.contextRoot + "/common/file/upload.do", formData);
				
				// 파일 업로드 실패 시
				for (let idx = this.value.length - 1; idx >= 0; idx--) {
					this.value.pop();
				}
				
				// 파일 추가
				for (let idx = 0; idx < response.data.fileList.length; idx++) {
					this.value.push(response.data.fileList[idx]);
				}
				
				// 파일 유형 체크
				let fileType = this.value[0].fileExtensionName.toLowerCase();
				
				if (fileType !== "pdf") {
					throw new Error("Only PDF files are supported.");
				}
				
				// PDF 파일 정보 설정
				const fileData = {
					fileNo: response.data.fileList[0].fileNo,
					fileGroupNo: response.data.fileList[0].fileGroupNo,
					serverFileSaveName: response.data.fileList[0].serverFileSaveName
				};
				
				// Step 2: PDF 이미지 변환
				const pdfResponse = await axios.post(
					this.config.contextRoot + "/common/file/convertPdfToPng.do", 
					fileData
				);
				
				if (pdfResponse.data.error) {
					throw new Error("Documents with more than 1 page are not supported.");
				}
				
				// 이미지 정보 설정
				this.imageInfo.imageUrl = pdfResponse.data.imagePreview;
				this.imageInfo.imageWidth = pdfResponse.data.imageWidth;
				this.imageInfo.imageHeight = pdfResponse.data.imageHeight;
				this.isDrawImage = true;
				
				// Step 3: 나중에 OCR 정보 걷어낼 용도
				const ocrVo = {
					fileList: response.data.fileList,
				}
				const ocrFileResponse = await axios.post(this.config.contextRoot + "/ocr/insertFile.do", ocrVo);
				
				if (ocrFileResponse.error) {
					throw new Error("Error occurred while inserting OCR file.");
				}
				
				this.items.fileNo = ocrFileResponse.data.fileNo;
				
				// Step 3: OCR 정보 추출
				const ocrFormData = new FormData();
				ocrFormData.append("file", this.ocrFile);
				ocrFormData.append("params", JSON.stringify({
					"pages": [], 
					"pre_process": {
						"rotation_90n": false, 
						"rotation_fine": false
					}
				}));
				
				const ocrResponse = await axios.post(
					this.config.contextRoot + "/lomin/api/v1/parsing", 
					ocrFormData, 
					{
						headers: {
							accept: "application/json",
							"Content-Type": "multipart/form-data"
						}
					}
				);
				
				console.log(`ocrResponse: ${JSON.stringify(ocrResponse.data)}`);
				
				this.logger.debug(this, "OCR Response:", ocrResponse.data);
				
				// OCR 데이터 설정
				this.parsedData = ocrResponse.data;
				
				if (this.parsedData)
				{
					// ocrResponse.data.parsed_resuls[0]의 texts 리스트에서 position = [a, b, c, d]일 때 ocrfieldlist의 position이 a,b,c,d의 값과 같거나 포함되는 경우의 text를 가져옴
					const parsedResultTable = this.$refs.parsedResultTable;
					parsedResultTable.classList.remove("hide");
					const parsedResults = this.parsedData?.parsed_result?.[0]?.texts || []; // parsed_results[0]의 texts 리스트
					this.ocrFieldList.forEach(field => {
						// field.position: [a, b, c, d]
						const [fx1, fy1, fx2, fy2] = field.position.map(Number);
						// 예시 = 0.848789688777114,0.2121414276184123,0.9424709210939954,0.23482321547698468
						// texts.position = [0.858485451344279,0.21587457322380907,0.9325238265898957,0.23377047001142803]
						// 오차 허용값 (예: 0.02)
						// 범주 안에 있는 texts.position을 찾기
						const findText = parsedResults.find(textObj => {
							if (!textObj.position || textObj.position.length !== 4) return false;
							const [tx1, ty1, tx2, ty2] = textObj.position.map(Number);
							return (
								tx1 >= fx1 - 0.02 && tx1 <= fx2 + 0.02 &&
								ty1 >= fy1 - 0.02 && ty1 <= fy2 + 0.02 &&
								tx2 >= fx1 - 0.02 && tx2 <= fx2 + 0.02 &&
								ty2 >= fy1 - 0.02 && ty2 <= fy2 + 0.02
							);
						});
						
						if (findText) {
							console.log(`findText: ${JSON.stringify(findText)}`);
							this.$set(field, 'parsedData', findText.text);
							if (field.dataTypeCd === "2") {
								let autoEditData = findText.text;
								autoEditData = autoEditData.replace(/[^0-9]/g, '');
								if (autoEditData.length > 1) {
									autoEditData = parseInt(autoEditData);
									this.$set(field, 'autoEditData', autoEditData);
								}
							}
						}
						else {
							this.$set(field, 'parsedData', '');
						}
					});
				}
				
			} catch (error) {
				if (error.message === "Only PDF files are supported.") {
					this.$alert(error.message, "Warning", "warning");
					this.fileName = "(100MB, Formats:PDF)";
				}
				else if (error.message === "Documents with more than 1 page are not supported.") {
					this.$alert(error.message, "Warning", "warning");
				}
				else {
					this.exceptionHandler(this, error);
				}
			} finally {
				EventBus.$emit("project-loading", false);
			}
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel ocr ?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.ocrFileUpload.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.ocrFileUpload.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("ocr-close", "isOcrFileUpload");
			}.bind(this), 410);
		},
		initializeCanvas() {
			this.logger.debug(this, "initializeCanvas()");
			
			// 이미 초기화되었다면 반복 작업 방지
			if (this.isInit) {
				return;
			}
			
			// 이미지 로드 전에 isInit 플래그를 true로 설정하여 중복 실행 방지
			this.isInit = true;
			
			setTimeout(() => {
				const canvas = this.$refs.drawingCanvas;
				const container = this.$refs.imageViewer;
				if (canvas && container) {
					const img = new window.Image();
					img.onload = () => {
						canvas.width = this.imageInfo.imageWidth;
						canvas.height = this.imageInfo.imageHeight;
						this.imageObj = img;
						this.drawImageAndAnnotations();
						
						// 초기화 이후에 한 번만 실행되도록 함
						this.$nextTick(() => {
							this.drawInitAnnotations();
						});
					}
					img.src = this.imageInfo.imageUrl;
				}
			}, 1500);
		},
		drawImageAndAnnotations() {
			this.logger.debug(this, "drawImageAndAnnotations()");
			const canvas = this.$refs.drawingCanvas;
			if (!canvas || !this.imageObj) return;
			const ctx = canvas.getContext('2d');
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			ctx.drawImage(this.imageObj, 0, 0, canvas.width, canvas.height);
		},
		drawInitAnnotations() {
			this.logger.debug(this, "drawInitAnnotations()");
			const canvas = this.$refs.drawingCanvas;
			if (!canvas || !this.imageObj) return;
			
			const context = canvas.getContext('2d');
			context.clearRect(0, 0, canvas.width, canvas.height);
			context.drawImage(this.imageObj, 0, 0, canvas.width, canvas.height);
			
			if (this.ocrFieldList && this.ocrFieldList.length > 0) {
				this.ocrFieldList.forEach((field) => {
					if (field.area && field.area.width > 0 && field.area.height > 0) {
						const isActive = this.selectedOcrField && this.selectedOcrField.fieldName === field.fieldName && this.selectedOcrField.pageNo === field.pageNo;
						
						switch (field.ocrFieldType || field.fieldType) {
							case 'square':
								this.drawFieldSquare(context, field, isActive);
								break;
							case 'divided':
								this.drawFieldDivided(context, field, isActive);
								break;
							case 'check':
								this.drawFieldCheck(context, field, isActive);
								break;
							default:
								this.drawFieldSquare(context, field, isActive);
								break;
						}
					}
				});
			}
		},
		drawFieldSquare(context, field, isActive) {
			const { x, y, width, height } = field.area;
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.lineWidth = 2;
			context.strokeRect(x, y, width, height);
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.fillRect(x, y, width, height);
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
			context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
			context.font = '32px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(field.fieldName, x + 10, y - 10);
		},
		drawFieldDivided(context, field, isActive) {
			const { x, y, width, height } = field.area;
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.lineWidth = 2;
			context.strokeRect(x, y, width, height);
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.fillRect(x, y, width, height);
			
			context.beginPath();
			context.moveTo(x + width / 2, y);
			context.lineTo(x + width / 2, y + height);
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.lineWidth = 2;
			context.stroke();
			
			context.font = '32px Pretendard bold';
			context.fillStyle = 'rgba(43, 173, 224, 0.9)';
			context.textAlign = 'center';
			context.textBaseline = 'middle';
			context.fillText('A', x + width / 4, y + height / 2);
			context.fillText('B', x + (width * 3) / 4, y + height / 2);
			
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
			context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
			context.font = '32px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(field.fieldName, x + 40, y - 20);
		},
		drawFieldCheck(context, field, isActive) {
			const { x, y, width, height } = field.area;
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.lineWidth = 2;
			context.strokeRect(x, y, width, height);
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.fillRect(x, y, width, height);
			
			const checkWidth = width * 0.7;
			const checkHeight = height * 0.5;
			const checkX = x + width * 0.15;
			const checkY = y + height * 0.5;
			
			context.beginPath();
			context.moveTo(checkX, checkY);
			context.lineTo(checkX + checkWidth * 0.3, checkY + checkHeight * 0.8);
			context.lineTo(checkX + checkWidth, checkY - checkHeight * 0.8);
			context.lineWidth = 4;
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.9)' : 'rgba(43, 173, 224, 0.9)';
			context.stroke();
			
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
			context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
			context.font = '32px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(field.fieldName, x + 15, y - 20);
		},
		selectAllFields() {
			this.logger.debug(this, "selectAllFields()");
			this.ocrFieldList.forEach(field => {
				field.checked = this.selectAll;
			});
		},
		async doSave() {
			/**
			 * OCR 결과값 저장 로직
			 * 
			 * 1. ocrFieldList에서 checked된 데이터만 필터링
			 * 2-1. checked된 항목이 없으면 alert 통해 메시지 출력
			 * 2-2. checked된 항목이 있으면 저장로직 실행
			 * 3. 저장 로직
			 *  템플릿 관련 테이블 tb_ocr, tb_ocr_field, tb_ocr_field_detail
			 *  템플릿을 통해 parsedData를 생성 관련 테이블 tb_ocr_entity, tb_ocr_entity_detail
			 *  tb_ocr_entity의 pk는 ocrEntityNo, FK는 screeningNo, ocrFieldNo, fileNo 필요
			 *  tb_ocr_entity_detail의 pk는 ocrEntityDetailNo, FK는 ocrEntityNo 필요, parsedData 입력
			 * 	1. checked된 항목의 editParsedData 값이 있다면 parsedData로 업데이트, 없다면 기존 parsedData로 유지
			 * 	2. checked된 항목의 parsedData를 ocrFieldListChecked에 추가
			 * 	3. axios로 저장 요청
			 */
			this.logger.debug(this, "doSave()");
			
			if (this.ocrFieldList.length === 0) {
				this.$alert("Please select a template first.", "Warning", "warning");
				return;
			}
			
			if (this.items.fileNo === null || this.items.fileNo === undefined || this.items.fileNo === "") {
				this.$alert("Please upload a file first.", "Warning", "warning");
				return;
			}
			
			const checkedFields = this.ocrFieldList.filter(field => field.checked);
			if (checkedFields.length === 0) {
				this.$alert("Please select at least one field to save.", "Warning", "warning");
				return;
			}
			
			EventBus.$emit("project-loading", true);
			
			// const screeningParam = {
			// 	screeningNo: this.items.screeningNo,
			// }
			// await axios.post(
			// 	this.config.contextRoot + "/ocr/entity/delete.do",
			// 	screeningParam
			// );
			
			// 원할한 트랜잭션을 위해 동시 처리
			for (const field of checkedFields) {
				let entityData = {
					ocrFieldNo: field.ocrFieldNo,
					screeningNo: this.items.screeningNo,
					visitNo: this.items.visitNo,
					fieldNo: field.fieldNo,
					fileNo: this.items.fileNo,
					fieldType: field.fieldType,
					procFieldNo: field.procFieldNo,
					procQuestionNo: field.procQuestionNo,
					parsedData: field.fieldType === 'check' ? (field.parsedData === '☑' ? field.checkValue : field.parsedData) : field.parsedData,
					resultData: field.editParsedData ? field.editParsedData : field.fieldType === 'check' ? (field.parsedData === '☑' ? field.checkValue : field.parsedData) : field.parsedData,
				};
				const entityResponse = await axios.post(this.config.contextRoot + "/ocr/entity/insert.do", entityData);
				entityData = {
					...entityData,
					ocrEntityNo: entityResponse.data.ocrEntityNo,
					ocrEntityDetailNo: entityResponse.data.ocrEntityDetailNo,
				};
				this.ocrEntityList.push(entityData);
			}
			this.$alert("Get OCR Result Data successfully saved.", "Success", "success");
			this.$emit("ocr-entity-list", this.ocrEntityList);
			
			this.$nextTick(function () {
				setTimeout(function() {
					EventBus.$emit("project-loading", false);
					this.doClose();
				}.bind(this), 400);
			});
		}
	},
}
</script>

<style scoped>
.dialog-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 9999;
	animation: fadein .4s ease-in-out both;
}

.table-set > input[type=number] {
	width: calc(50% - 15px);
}

.table-set > span {
	width: 30px;
	text-align: center;
}

.field-parsed-result {
	max-height: calc(100% - 50px);
	overflow-y: auto;
}

.field-parsed-result::-webkit-scrollbar {
	width: 20px;
}

.field-parsed-result::-webkit-scrollbar-thumb {
	float: right;
	border: 7px solid transparent;
	border-radius: 20px;
	background: linear-gradient(to top, #2bade0, #9ecc5a);
	background-clip: padding-box;
}

.field-parsed-result::-webkit-scrollbar-track {
	background-color: #fff;
}

.check-row > td {
	background-color: #f7f7f7;
}

.elipsis-row {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.tb-list-input {
	width: 100%;
	height: 100%;
	border: 1px solid #CCC;
	border-radius: 4px;
	outline: none;
	font-size: 12px;
	font-weight: bold;
	text-align: center;
}

.tb-list-input__readonly {
	border: none;
	outline: none;
	background-color: transparent;
	max-width: 80px;
	text-align: center;
	font-weight: bold;
}

.unfocus-text,
.table-head {
	display: flex;
	justify-content: inherit;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 0 10px;
	font-weight: inherit;
	font-size: 10pt;
	overflow: hidden;
	z-index: 15;
}

.table-data {
	display: flex;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 0 10px;
	font-weight: inherit;
	font-size: 10pt;
	overflow: hidden;
	z-index: 1;
}

.survey-field-list {
	width: 100%;
	font-weight: 600 !important;
	font-size: 10pt !important;
	color: #666;
	overflow-y: visible;
}

.survey-field-vtype,
.survey-field-htype {
	max-width: 100%;
	font-weight: 400 !important;
}

.input-crud-error::placeholder {
	color: rgb(224, 91, 91);
}
.date-picker{
	position: relative;
}
.hide {
	display: none;
}
.survey-name-ocr{
	display: grid;
	grid-template-columns: 200px 1fr 200px 1fr;
	top: 30px;
	width: 100%;
	height: 45px;
	border-top: 1px solid #ccc;
}
.survey-center-ocr{
	display: flex;
	min-height: calc(100% - 171px);
	height: calc(100% - 171px);
	margin-top: 30px;
}
.survey-left-ocr{
	width: 75%;
	height: 100%;
	border: 1px solid #ccc;
	border-right: none;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #E4E4E4;
	color: #999;
	font-weight: bold;
	font-size: 25px;
	cursor: pointer;
}
.survey-right-ocr{
	width: 25%;
	height: 100%;
	border: 1px solid #ccc;
}
.field-spec-header{
	width: 100%;
	height: 50px;
	background-color: #FAFAFA;
	display: flex;
	align-items: center;
	padding-left: 20px;
	color: #2BADE0;
	font-weight: bold;
	font-size: 13px;
	border-bottom: 1px solid #ccc;
}
.field-spec-sub{
	width: 100%;
	height: 50px;
	display: flex;
	align-items: center;
	padding-left: 20px;
	font-weight: bold;
	font-size: 13px;
	color: #999999;
}
.field-type-list{
	display: flex;
	justify-content: center;
	column-gap: 10px;
	padding: 0 10px 0 10px;
}
.field-type-btn{
	flex: 1;
	height: 70px;
	background-color: #FAFAFA;
	border-radius: 4px;
	border: #E5E8EB 1px solid;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	row-gap: 6.5px;
	font-size: 12px;
	font-weight: bold;
	color: #CCCCCC;
}
.field-type-btn:hover{
	border: #2BADE0 1px solid;
	box-shadow: none;
	color: #2BADE0;
}
.field-type-img-1{
	width: 80%;
	height: 24px;
	background-color: #fff;
	/* border: 1px solid #707070; */
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-2{
	width: 80%;
	height: 24px;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
}
.field-type-img-3{
	width: 40%;
	height: 24px;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-sub{
	width: 50%;
	height: 100%;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-sub:first-child{
	border-right: none;
}
.ocr-field-list {
	width: 100%;
	display: grid;
	gap: 20px;
	margin: 20px 0;
	padding: 0 10px 0 10px;
	max-height: calc(100% - 200px);
	overflow-y: auto;
}
.ocr-field-list::-webkit-scrollbar {
	width: 20px;
}

.ocr-field-list::-webkit-scrollbar-thumb {
	float: right;
	border: 7px solid transparent;
	border-radius: 20px;
	background: linear-gradient(to top, #2bade0, #9ecc5a);
	background-clip: padding-box;
}

.ocr-field-list::-webkit-scrollbar-track {
	background-color: #fff;
}
.ocr-field-item {
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #f4f4f4;
}
.ocr-field-item:hover {
	border-color: #2BADE0;
	box-shadow: 0 2px 5px rgba(0,0,0,0.1);
	cursor: pointer;
}
.ocr-field-item.selected {
	border: 2px solid #2BADE0;
	background-color: rgba(43, 173, 224, 0.05);
}
.ocr-field-item.selected::before {
	content: '';
	position: absolute;
	left: -10px;
	top: 50%;
	transform: translateY(-50%);
	width: 0;
	height: 0;
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	border-right: 8px solid #2BADE0;
}
.ocr-field-title {
	width: 100%;
	height: 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 10px;
	background-color: #FAFAFA;
	border-bottom: 1px solid #ccc;
}
.ocr-field-serial {
	font-size: 13px;
	font-weight: bold;
	color: #999;
}
.orc-field-icon {
	display: flex;
	flex-wrap: nowrap;
	gap: 1rem;
}
.ocr-field-content {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 3fr;
	gap: 10px;
	padding: 20px 10px;
}
.ocr-field-category {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.ocr-field-text {
	font-size: 13px;
	color: #666;
}
.ocr-field-box {
	width: 100%;
}
.pdf-container {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: #f4f4f4;
}
.canvas-container {
	position: absolute;
	top: 0;
	left: 0;
	/* width: 100%; */
	/* height: 100%; */
	z-index: 10;
	pointer-events: none;
}
.canvas-container.canvas-active {
	pointer-events: auto;
}
.drawing-canvas {
	width: 100%;
	height: 100%;
	cursor: crosshair;
}
.canvas-controls {
	position: sticky;
	top: 10px;
	left: 10px;
	float: left;
	z-index: 20;
	background-color: rgba(255, 255, 255, 0.8);
	padding: 5px;
	border-radius: 5px;
	box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.canvas-control-btn {
	padding: 5px 10px;
	background-color: #f8f8f8;
	border: 1px solid #ccc;
	border-radius: 3px;
	cursor: pointer;
	font-size: 12px;
}
.canvas-control-btn:hover {
	background-color: #efefef;
}
.drawing-tools {
	position: sticky;
	top: 10px;
	right: 10px;
	background-color: rgba(255, 255, 255, 0.8);
	float: right;
	z-index: 20;
	width: fit-content;
	display: flex;
	padding: 5px;
	border-radius: 5px;
	box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.drawing-tool {
	width: 30px;
	height: 30px;
	margin: 0 5px;
	border: 1px solid #ccc;
	background-color: white;
	border-radius: 3px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
.drawing-tool:hover {
	background-color: #f0f0f0;
}
.tool-icon {
	font-size: 18px;
	line-height: 1;
}
.save-icon {
	color: #2cb42c;
}
.cancel-icon {
	color: #ff3b3b;
}
.edit-icon {
	background-image: url("~@/assets/images/project/btn_write_survey.png");
}
.elipsis-input {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.btn-edit, .btn-delete {
	width: 24px;
	height: 24px;
	background-color: transparent;
	border: none;
	cursor: pointer;
	background-repeat: no-repeat;
	background-position: center;
}
.btn-edit {
	background-image: url("~@/assets/images/project/btn_write_survey.png");
}
.btn-delete {
	background-image: url("~@/assets/images/project/btn_delete.png");
}
</style>